import { render } from "./DesktopMenuPopoutTop.vue?vue&type=template&id=1c0d2748&scoped=true"
import script from "./DesktopMenuPopoutTop.vue?vue&type=script&lang=js"
export * from "./DesktopMenuPopoutTop.vue?vue&type=script&lang=js"

import "./DesktopMenuPopoutTop.vue?vue&type=style&index=0&id=1c0d2748&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0d2748"]])

export default __exports__